/**
 * Application Constants
 * Centralized constants for the application
 */

// Page IDs
export const PAGE_IDS = {
  MAP: 'map',
  JOBS: 'jobs',
  LISTINGS: 'listings',
  ETL_PIPELINE: 'etl_pipeline',
  QUEUE_MONITOR: 'queue_monitor',
  API_KEYS: 'api_keys',
  BATCH_JOB_RUNNER: 'batch_job_runner',
  BATCH_JOBS: 'batch_jobs',
  INSTAGRAM: 'instagram',
  NEWS_SIGNALS: 'news_signals',
  SOCIAL_YTTT: 'social_yttt',
  DATA_PLATFORM: 'data_platform',
  AUTH: 'auth',
  ENTITY_RESOLUTION: 'entity_resolution',
  RESPIDER: 'respider',
  PIPELINE_STATUS: 'pipeline-status',
  GMAPS_REVIEWS: 'gmaps_reviews',
  MENU_OCR: 'menu_ocr',
  OUTLETS: 'outlets',
  SERPER_ENRICHER: 'serper_enricher',
};

// Page Titles
export const PAGE_TITLES = {
  [PAGE_IDS.MAP]: 'Map Selector',
  // Not "All Jobs": that is the name of a FILTER inside this page ("All Jobs"
  // vs "My Jobs"), and the page itself is the finder's job list — its run
  // modes are Deep Dive / Continuous / Fast Scan. Not "Discovery" either:
  // `discovery/` is a different, live subsystem (the pooled crawler on the
  // Delivery Readiness health strip) and the collision would be worse.
  [PAGE_IDS.JOBS]: 'Finder Jobs',
  [PAGE_IDS.ETL_PIPELINE]: 'ETL Pipeline',
  [PAGE_IDS.QUEUE_MONITOR]: 'Fleet Monitor',
  [PAGE_IDS.API_KEYS]: 'API Keys',
  [PAGE_IDS.BATCH_JOB_RUNNER]: 'Batch Job Runner',
  [PAGE_IDS.BATCH_JOBS]: 'Batch Jobs',
  [PAGE_IDS.INSTAGRAM]: 'Instagram',
  // News ingestion operations; distinct from the customer Signals feature.
  [PAGE_IDS.NEWS_SIGNALS]: 'News Signals',
  [PAGE_IDS.SOCIAL_YTTT]: 'YouTube & TikTok',
  [PAGE_IDS.DATA_PLATFORM]: 'Lakehouse',
  [PAGE_IDS.ENTITY_RESOLUTION]: 'Entity Resolution',
  [PAGE_IDS.RESPIDER]: 'Respider',
  // Not "Pipeline Status": that named the smallest band on the page, the
  // health strip. The page answers "can this country be delivered today?" —
  // freshness against the 30-day window and how much processing is left.
  // Note it does NOT measure quality in the accuracy sense; nothing here
  // checks whether a value is right, only whether it is current and present.
  [PAGE_IDS.PIPELINE_STATUS]: 'Delivery Readiness',
  [PAGE_IDS.GMAPS_REVIEWS]: 'Google Maps Reviews',
  [PAGE_IDS.MENU_OCR]: 'Image OCR',
  [PAGE_IDS.OUTLETS]: 'Outlet Profile',
  [PAGE_IDS.SERPER_ENRICHER]: 'Serper Enricher',
};

// API Endpoints
export const API_ENDPOINTS = {
  JOBS: '/api/jobs',
  MAP: '/api/map',
  REGIONS: '/api/regions',
  SPIDERS: '/api/spiders',
  FIREBASE_CONFIG: '/auth/config/firebase',
};

// Job Status
export const JOB_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  FINISHED: 'finished',
  CANCELLED: 'cancelled',
  ERROR: 'error',
};

// Toast Types
export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

// Storage Keys
export const STORAGE_KEYS = {
  FIREBASE_TOKEN: 'firebase_token',
  USER_PREFERENCES: 'user_preferences',
};

// Default Values
export const DEFAULTS = {
  MAP_CENTER: [1.3521, 103.8198], // Singapore
  MAP_ZOOM: 11,
  ITEMS_PER_PAGE: 50,
  REFRESH_INTERVAL: 60000, // 1 minute
};

// Validation Rules
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  MIN_PASSWORD_LENGTH: 6,
};
